import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import PartnerPage from '../pages/partner/page';
import SuccessPage from '../pages/success/page';
import ReasonPage from '../pages/reason/page';
import PricePage from '../pages/price/page';
import FaqPage from '../pages/faq/page';
import ContactPage from '../pages/contact/page';
import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog-detail/page';
import AdminBlogPage from '../pages/admin/blog/page';
import AdminPage from '../pages/admin/page';
import ServicePage from '../pages/service/page';
import EnrollmentPage from '../pages/enrollment/page';
import GreetingPage from '../pages/greeting/page';
import PrivacyPage from '../pages/privacy/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/greeting', element: <GreetingPage /> },
  { path: '/service', element: <ServicePage /> },
  { path: '/enrollment', element: <EnrollmentPage /> },
  { path: '/partner', element: <PartnerPage /> },
  { path: '/success', element: <SuccessPage /> },
  { path: '/reason', element: <ReasonPage /> },
  { path: '/price', element: <PricePage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:id', element: <BlogDetailPage /> },
  { path: '/admin/blog', element: <AdminBlogPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
